import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericDelete } from '@/_shared/types/swagger';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_USER_CONTENT_FAVORITES_CONTENTID_PATH_KEY } from '@/swagger/constants/contents-orchestrator-keys';
import { KEY_DELETE_CONTENTS_FAVORITES, API_DELETE_CONTENTS_FAVORITES } from '../constants';
import { MOCK_RESPONSE_DELETE_CONTENTS_FAVORITES } from '../mocks';

export type RequestDeleteContentsFavorites = GenericDelete<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_USER_CONTENT_FAVORITES_CONTENTID_PATH_KEY
>['request']['path'];

export type ResponseDeleteContentsFavorites = GenericDelete<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_USER_CONTENT_FAVORITES_CONTENTID_PATH_KEY
>['response']['body'];

export type CallParamsDeleteContentsFavorites = Omit<
  RequestDeleteContentsFavorites,
  'organizationId'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponseDeleteContentsFavorites = ResponseDeleteContentsFavorites;

type CallErrorDeleteContentsFavorites = {
  message: string;
  code: number;
};

type CallSelectorsDeleteContentsFavorites = unknown;

export const deleteContentsFavoritesCall = createGeneralCall<
  CallParamsDeleteContentsFavorites,
  CallResponseDeleteContentsFavorites,
  CallErrorDeleteContentsFavorites,
  CallSelectorsDeleteContentsFavorites
>({
  id: KEY_DELETE_CONTENTS_FAVORITES,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_DELETE_CONTENTS_FAVORITES(org as unknown as string, payload.contentId);
    },
  method: 'delete',
  paramsSelector:
    ({ payload }) =>
    () => {
      return {
        ...payload,
      };
    },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_DELETE_CONTENTS_FAVORITES : undefined,
});
